import { render, staticRenderFns } from "./GeodeticProjectViewList.vue?vue&type=template&id=beb4a9be&scoped=true&"
import script from "./GeodeticProjectViewList.vue?vue&type=script&lang=ts&"
export * from "./GeodeticProjectViewList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb4a9be",
  null
  
)

export default component.exports